import React from 'react';
import { IAuditoriaPddAnaliticaResultado } from '../interfaces/IAuditoriaPddAnalitica';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaPddAnaliticaResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Governança de PDD e Composição Analítica de Saldos — Partes Relacionadas vs. Terceiros.
// Fundamentação: CPC 48 (IFRS 9) / Lei 6.404/1976, Art. 183, § 1º / RIR/2018, Art. 343.
const AuditoriaResumoPddAnalitica: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = (resultado.saldosPendentes || []).length;
  const totalIndedutiveis = (resultado.saldosPendentes || []).filter((item) => item.indedutivelFiscal).length;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de PDD e Composição Analítica de Saldos</h3>
      <p className='text-muted'>
        Saldos de Clientes (Terceiros e Partes Relacionadas) em aberto há mais de 60 dias exigem revisão de
        risco de crédito e composição de PDD (CPC 48 / IFRS 9). PDD sobre Partes Relacionadas é 100%
        indedutível fiscal (RIR/2018, Art. 343, § 5º). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Multa ECD / Saldo em Aberto</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_PDD_ANALITICA')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Governança de PDD (Partes Relacionadas vs. Terceiros)</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} saldo{totalOcorrencias === 1 ? '' : 's'} pendente{totalOcorrencias === 1 ? '' : 's'} no período, {totalIndedutiveis} indedutível{totalIndedutiveis === 1 ? '' : 'eis'} (Partes Relacionadas)</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Saldo em aberto total: {formatCurrency(resultado.impactoFinanceiroTotal)}</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoPddAnalitica;
